'use client'

// import { useState, useEffect } from 'react'
// import { createClientComponentClient } from "@supabase/auth-helpers-nextjs"
import { useIsMobile } from '@/hooks/use-mobile'
import Navbar from '@/components/home/Navbar'
import Hero from '@/components/home/Hero'
import Community from '@/components/home/Community'
import FeaturedVideo from '@/components/home/FeaturedVideo'
import Learning from '@/components/home/Learning'
import Tools from '@/components/home/Tools'
import AIBuilderPack from '@/components/home/AIBuilderPack'
import Testimonials from '@/components/home/Testimonials'
import Pricing from '@/components/home/Pricing'
import Footer from '@/components/home/Footer'
import { createClientComponentClient } from '@supabase/auth-helpers-nextjs'
import { useEffect } from 'react'

export default function HomeContent() {
  // debugger;
  const supabase = createClientComponentClient();
  const isMobile = useIsMobile();
  // const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
      } catch (e) {
        console.log("[/] Home page useEffect: User not logged in or error fetching", e);
      }
    };
    fetchUser();
  }, [supabase]);

  return (
    <main className="bg-background text-white">
      <Navbar isMobile={isMobile} />
      <Hero isMobile={isMobile} />
      <Community isMobile={isMobile} />
      <FeaturedVideo isMobile={isMobile} />
      <Learning isMobile={isMobile} />
      <Tools isMobile={isMobile} />
      <AIBuilderPack isMobile={isMobile} />
      <Testimonials isMobile={isMobile} />
      <Pricing isMobile={isMobile} />
      <Footer isMobile={isMobile} />
    </main>
  )
}
